/* CLM v2 (site-style, main theme layout) — shared JS for the CLM inventory / vehicle / quote / service pages (unpublished theme copy only).
   EXAMPLE finance assumptions are placeholders (not an offer). Real terms come from the lender (Synchrony / Sheffield). */
(function () {
  'use strict';
  if (window.__clmSalesInit) return; window.__clmSalesInit = true; // run once: the site-wide pop-up may load this file too
  var EX = { apr: 8.99, term: 60, down: 1000 };
  function monthly(price, down, apr, term) {
    var p = Math.max(0, price - down), r = apr / 1200;
    if (!p) return 0; if (!r) return p / term;
    return p * r / (1 - Math.pow(1 + r, -term));
  }
  function fmt(n) { return '$' + Math.round(n).toLocaleString('en-US'); }
  function $all(s, el) { return Array.prototype.slice.call((el || document).querySelectorAll(s)); }
  var qs = new URLSearchParams(location.search);

  /* 1. Attribution: FIRST-TOUCH, kept 30 days in localStorage (mirrored to sessionStorage) so it survives
        navigation to the quote page and return visits. A first touch with no campaign params is replaced
        by a later touch that has fbclid/UTMs (so a paid click after an organic visit still counts as paid).
        The relay (not the theme) decides the lead source/channel from fbclid + utm_source. */
  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid'];
  var ATTR_KEY = 'clm_attr_v1', ATTR_TTL = 30 * 864e5;
  function readAttr(store) { try { var a = JSON.parse(store.getItem(ATTR_KEY) || 'null'); return a && Date.now() - a.ts < ATTR_TTL ? a : null; } catch (e) { return null; } }
  function writeAttr(a) { var j = JSON.stringify(a); try { localStorage.setItem(ATTR_KEY, j); } catch (e) {} try { sessionStorage.setItem(ATTR_KEY, j); } catch (e) {} }
  var attr = null; try { attr = readAttr(localStorage); } catch (e) {} if (!attr) { try { attr = readAttr(sessionStorage); } catch (e) {} }
  (function () {
    var cur = {}, has = false;
    KEYS.forEach(function (k) { var v = qs.get(k); if (v) { cur[k] = v.slice(0, 500); has = true; } });
    if (!attr || (has && !attr.campaign)) {
      attr = { ts: Date.now(), campaign: has, landing_page: location.href.slice(0, 1000), referrer: (document.referrer || '').slice(0, 1000) };
      KEYS.forEach(function (k) { attr[k] = cur[k] || ''; });
      writeAttr(attr);
    }
  })();
  function ss(k) { return (attr && attr[k]) || ''; }
  /* Ad lead = first-touch utm_source facebook family + utm_medium=paid + utm_campaign=clm-inhouse (case-insensitive).
     Only then lead_source=CLM-InHouse-Meta and the "[CLM-InHouse]" subject tag are set. Everything else leaves lead_source
     blank so the relay classifies it (fbclid / utm_source -> Facebook or Organic) exactly as before. */
  var AD_SRC = ['facebook', 'fb', 'instagram', 'ig', 'meta'];
  function isAdLead() {
    function n(k) { return String(ss(k) || '').trim().toLowerCase(); }
    return AD_SRC.indexOf(n('utm_source')) > -1 && n('utm_medium') === 'paid' && n('utm_campaign') === 'clm-inhouse';
  }
  function markLead() { try { sessionStorage.setItem('clm_lead_pending', String(Date.now())); } catch (e) {} } // consumed by the thank-you page pixel

  /* Lead relay (Railway clm-lead-relay -> Housecall Pro + GHL desk text). Empty = old behaviour (native Shopify submit only).
     Flow: POST to relay first; on {ok:true} go to the thank-you page; on any failure/timeout fall back to the native Shopify contact form. */
  var RELAY_URL = 'https://clm-lead-relay-production.up.railway.app/lead';
  var RELAY_TIMEOUT_MS = 8000;
  function relaySend(f) {
    if (!RELAY_URL || RELAY_URL.indexOf('__') === 0 || !window.fetch) return Promise.reject(new Error('no relay'));
    var body = new URLSearchParams();
    new FormData(f).forEach(function (v, k) { if (typeof v === 'string' && k !== 'form_type' && k !== 'utf8' && k.indexOf('g-recaptcha') !== 0 && k.indexOf('h-captcha') !== 0) body.append(k, v); });
    var ctl = window.AbortController ? new AbortController() : null;
    var t = setTimeout(function () { if (ctl) ctl.abort(); }, RELAY_TIMEOUT_MS);
    return fetch(RELAY_URL, { method: 'POST', body: body, mode: 'cors', credentials: 'omit', keepalive: true, signal: ctl ? ctl.signal : undefined })
      .then(function (r) { clearTimeout(t); return r.ok ? r.json() : Promise.reject(new Error('relay ' + r.status)); })
      .then(function (d) { if (!d || d.ok !== true) throw new Error('relay not ok'); return d; });
  }

  (function (fn) { if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn); else fn(); })(function () { // also runs when loaded late by the pop-up
    /* 2. Lead forms (native Shopify contact form) */
    var posted = document.querySelector('[data-clm-posted]');
    if (posted) { var pf = posted.closest('form'); location.replace((pf && pf.getAttribute('data-clm-return')) || '/pages/thank-you-sales'); return; } // fallback if return_to is ignored
    $all('form.lead').forEach(function (f) {
      f.setAttribute('novalidate', 'novalidate');
      KEYS.concat(['landing_page', 'referrer']).forEach(function (k) {
        var el = f.querySelector('[name="contact[' + k + ']"]'); if (el) el.value = ss(k);
      });
      var ad = isAdLead();
      var ls = f.querySelector('[name="contact[lead_source]"]'); if (ls) ls.value = ad ? 'CLM-InHouse-Meta' : ''; // relay still decides the channel for everything else
      var v = f.querySelector('[data-clm-vehicle]');
      if (v && !v.value && qs.get('vehicle')) {
        v.value = qs.get('vehicle');
        var sj = f.querySelector('[data-clm-subject]'); if (sj && sj.value.indexOf(' - ') < 0) sj.value += ' - ' + qs.get('vehicle');
      }
      var sj2 = f.querySelector('[data-clm-subject]'); // native-fallback email subject: tag only ad leads
      if (sj2) { sj2.value = sj2.value.replace(/^\[CLM-InHouse\]\s*/, ''); if (ad) sj2.value = '[CLM-InHouse] ' + sj2.value; }
      var i = f.querySelector('[data-clm-interest]');
      if (i && qs.get('interest')) { $all('option', i).forEach(function (o) { if (o.text === qs.get('interest')) i.value = o.text; }); }
      /* honeypot: invisible to people, bots fill it; the relay drops those submissions */
      if (!f.querySelector('[name="contact[hp_website]"]')) {
        var hp = document.createElement('input');
        hp.type = 'text'; hp.name = 'contact[hp_website]'; hp.tabIndex = -1; hp.autocomplete = 'off'; hp.setAttribute('aria-hidden', 'true');
        hp.style.cssText = 'position:absolute;left:-9999px;width:1px;height:1px;opacity:0';
        f.appendChild(hp);
      }
      if (f.hasAttribute('data-ce-form')) return; // CLM request form (snippets/clm-request-form) has its own submit handler
      f.addEventListener('submit', function (e) {
        if (f._clmFallback) return; // second pass: let the native Shopify contact form submit
        if (!f.reportValidity()) { e.preventDefault(); return; }
        var fn = f.querySelector('[name="contact[first_name]"]'), ln = f.querySelector('[name="contact[last_name]"]'), nm = f.querySelector('[name="contact[name]"]');
        if (nm) nm.value = ((fn && fn.value) + ' ' + (ln && ln.value)).trim();
        var b = f.querySelector('button[type=submit]'); if (b) { b.disabled = true; b.textContent = 'Sending…'; }
        if (!RELAY_URL || RELAY_URL.indexOf('__') === 0) return; // relay not configured: native submit as before
        e.preventDefault();
        relaySend(f).then(function () {
          markLead();
          location.href = f.getAttribute('data-clm-return') || '/pages/thank-you-sales';
        }).catch(function () {
          f._clmFallback = true; markLead();
          var h = f.querySelector('[name="contact[hp_website]"]'); if (h && !h.value) h.remove();
          if (b) b.disabled = false;
          if (f.requestSubmit) f.requestSubmit(); else f.submit();
          if (b) b.disabled = true;
        });
      });
    });
    var vnote = document.querySelector('[data-clm-vehicle-note]');
    if (vnote && qs.get('vehicle')) { vnote.textContent = 'About: ' + qs.get('vehicle'); vnote.style.display = 'block'; }
    if (qs.get('type') === 'service') { $all('[data-ty]').forEach(function (el) { el.style.display = el.getAttribute('data-ty') === 'service' ? '' : 'none'; }); }

    /* 3. Example payment estimates on cards and VDP */
    $all('[data-mo-price]').forEach(function (el) { el.textContent = fmt(monthly(+el.getAttribute('data-mo-price'), EX.down, EX.apr, EX.term)); });

    /* 4. (v2) site header/menu come from the main theme; nothing to do here */

    /* 5. Vehicle page: gallery, estimator, tabs, description */
    var ths = $all('.th[data-src]'), gimg = document.getElementById('gimg'), gc = document.getElementById('gcount'), gi = 0;
    function show(n) {
      if (!ths.length) return; gi = (n + ths.length) % ths.length;
      gimg.removeAttribute('srcset'); gimg.src = ths[gi].getAttribute('data-src');
      if (gc) gc.textContent = (gi + 1) + ' / ' + ths.length;
      ths.forEach(function (t, k) { t.classList.toggle('on', k === gi); });
    }
    ths.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var pv = document.querySelector('.gal-main .prev'), nx = document.querySelector('.gal-main .next');
    if (pv) pv.addEventListener('click', function () { show(gi - 1); });
    if (nx) nx.addEventListener('click', function () { show(gi + 1); });

    var calc = document.querySelector('[data-clm-calc]');
    if (calc) {
      var price = +calc.dataset.price, term = +calc.dataset.term || EX.term;
      var cd = document.getElementById('c_down'), ca = document.getElementById('c_apr');
      var run = function () {
        document.getElementById('c_downv').textContent = fmt(+cd.value);
        document.getElementById('c_aprv').textContent = (+ca.value).toFixed(2) + '%';
        document.getElementById('c_out').textContent = fmt(monthly(price, +cd.value, +ca.value, term));
      };
      cd.addEventListener('input', run); ca.addEventListener('input', run);
      $all('#c_term button').forEach(function (b) { b.addEventListener('click', function () { $all('#c_term button').forEach(function (x) { x.classList.remove('on'); }); b.classList.add('on'); term = +b.dataset.t; run(); }); });
      run();
    }
    function tab(t) {
      ['quote', 'drive', 'trade'].forEach(function (k) { var el = document.getElementById('f_' + k); if (el) el.style.display = k === t ? '' : 'none'; });
      $all('#tabs button').forEach(function (b) { b.classList.toggle('on', b.dataset.tab === t); });
    }
    $all('[data-tab]').forEach(function (b) { b.addEventListener('click', function () { tab(b.dataset.tab); }); });
    var dt = document.querySelector('[data-clm-desc-toggle]'), dd = document.querySelector('[data-clm-desc]');
    if (dt && dd) dt.addEventListener('click', function () { var c = dd.classList.toggle('clamp'); dt.textContent = c ? 'Read more' : 'Show less'; });

    /* 6. Inventory filters (client-side over rendered cards) */
    var inv = document.getElementById('clm-inv');
    if (inv) {
      var grid = document.getElementById('grid'), cards = $all('#grid > .clm2-card');
      var el = function (id) { return document.getElementById(id); };
      var sel = { make: el('f-make'), seats: el('f-seats'), power: el('f-power'), status: el('f-status'), max: el('f-max') };
      var st = { quick: 'all', sort: 'featured', cond: qs.get('cond') || '' };
      var setSel = function (s, v) { if (!s || !v) return; $all('option', s).forEach(function (o) { if (o.value === v) s.value = v; }); };
      setSel(sel.make, qs.get('make')); setSel(sel.seats, qs.get('seats')); setSel(sel.power, qs.get('power')); setSel(sel.status, qs.get('status'));
      if (qs.get('max')) { var mx = +qs.get('max'), best = ''; $all('option', sel.max).forEach(function (o) { if (o.value && +o.value >= mx && (!best || +o.value < +best)) best = o.value; }); sel.max.value = best; }
      if (st.cond === 'New') st.quick = 'new'; else if (st.cond) st.quick = 'pre';
      var d = function (c, k) { return c.getAttribute('data-' + k); };
      var match = function (c) {
        var showSold = el('f-sold').checked;
        if (!showSold && d(c, 'sold') === '1') return false;
        if (sel.make.value && d(c, 'make') !== sel.make.value) return false;
        if (sel.seats.value && d(c, 'seats') !== sel.seats.value) return false;
        if (sel.power.value && d(c, 'power') !== sel.power.value) return false;
        if (sel.status.value && d(c, 'status') !== sel.status.value) return false;
        if (sel.max.value && +d(c, 'price') > +sel.max.value) return false;
        if (el('f-lsv').checked && d(c, 'lsv') !== 'yes') return false;
        if (st.quick === 'new' && d(c, 'cond') !== 'New') return false;
        if (st.quick === 'pre' && d(c, 'cond') === 'New') return false;
        if (st.quick === 'sale' && d(c, 'sale') !== '1') return false;
        return true;
      };
      var rank = { available: 0, pending: 1, incoming: 2, sold: 3 };
      var band = document.getElementById('clm-cta-band');
      var render = function () {
        var list = cards.filter(match), s = st.sort;
        list.sort(function (a, b) {
          return ((rank[d(a, 'status')] || 0) - (rank[d(b, 'status')] || 0)) || (s === 'price_low' ? d(a, 'price') - d(b, 'price') : s === 'price_high' ? d(b, 'price') - d(a, 'price') : s === 'year' ? (+d(b, 'year') || 0) - (+d(a, 'year') || 0) : (d(b, 'featured') - d(a, 'featured')) || d(b, 'price') - d(a, 'price'));
        });
        cards.forEach(function (c) { c.style.display = 'none'; });
        var old = grid.querySelector('.clm2-band'); if (old) old.remove();
        list.forEach(function (c, k) {
          c.style.display = ''; grid.appendChild(c);
          if (k === 5 && list.length > 6 && band) grid.appendChild(band.content.cloneNode(true));
        });
        el('cnt').textContent = list.length;
        el('empty').style.display = list.length ? 'none' : '';
      };
      Object.keys(sel).forEach(function (k) { sel[k].addEventListener('change', render); });
      el('f-lsv').addEventListener('change', render); el('f-sold').addEventListener('change', render);
      el('sort').addEventListener('change', function (e) { st.sort = e.target.value; render(); });
      $all('#quick button[data-q]').forEach(function (b) {
        b.classList.toggle('on', b.dataset.q === st.quick);
        b.addEventListener('click', function () { $all('#quick button').forEach(function (x) { x.classList.remove('on'); }); b.classList.add('on'); st.quick = b.dataset.q; render(); });
      });
      el('reset').addEventListener('click', function () {
        Object.keys(sel).forEach(function (k) { sel[k].value = ''; }); el('f-lsv').checked = false; el('f-sold').checked = false;
        st.quick = 'all'; $all('#quick button').forEach(function (x) { x.classList.toggle('on', x.dataset.q === 'all'); }); render();
      });
      var mf = document.querySelector('[data-clm-mfilter]'), fl = document.querySelector('[data-clm-filters]');
      if (mf && fl) mf.addEventListener('click', function () { var o = fl.classList.toggle('mopen'); mf.setAttribute('aria-expanded', o); });
      if (Object.keys(sel).some(function (k) { return sel[k].value; }) && fl) fl.classList.add('mopen');
      render();
    }
  });
})();
